export var OPERATION_TYPE;
(function (OPERATION_TYPE) {
    OPERATION_TYPE["CROSS_CHAIN"] = "CROSS_CHAIN";
    OPERATION_TYPE["APPROVE"] = "APPROVE";
    OPERATION_TYPE["DEFAULT"] = "DEFAULT";
})(OPERATION_TYPE || (OPERATION_TYPE = {}));
